import UserPermissionsList from './UserPermissionsList';
export default UserPermissionsList;
